// Centralized data-testid registry for BODEGA portfolio site
export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkWork: "nav-link-work",
  linkProcess: "nav-link-process",
  linkContact: "nav-link-contact",
};

export const HERO = {
  section: "hero-section",
  title: "hero-title",
  subtitle: "hero-subtitle",
  bio: "hero-bio",
  cta: "hero-cta-button",
  scrollIndicator: "hero-scroll-indicator",
};

export const SERVICES = {
  section: "services-section",
  card: (i) => `service-card-${i}`,
};

export const CASES = {
  section: "case-studies-section",
  card: (i) => `case-card-${i}`,
};

export const WORKFLOW = {
  section: "workflow-section",
  step: (i) => `workflow-step-${i}`,
};

export const FOOTER = {
  section: "footer-section",
  email: "footer-email",
  phone: "footer-phone",
  linkedin: "footer-linkedin",
  portfolio: "footer-portfolio",
};

export const HOME = {
  emergentLink: "emergent-link",
};
